import { z } from 'zod'

import { EMPLOYEE_COUNT_OPTIONS } from '@/app/(sfc)/corp/(lp)/_data'

// 項目名・上限文字数は受付 API (POST /user/inquiries/introductionMaterialRequest) に合わせる
const MAX_LENGTH = 255
const MESSAGE_MAX_LENGTH = 5000

const requiredText = (label: string, requiredMessage: string) =>
  z
    .string()
    .trim()
    .min(1, requiredMessage)
    .max(MAX_LENGTH, `${label}は${MAX_LENGTH}文字以内で入力してください`)

export const corpInquirySchema = z.object({
  companyName: requiredText('会社名', '会社名を入力してください'),
  departmentName: requiredText('部署名', '部署名を入力してください'),
  contactPersonName: requiredText(
    'ご担当者様のお名前',
    'ご担当者様のお名前を入力してください',
  ),
  employeeCount: z.enum(EMPLOYEE_COUNT_OPTIONS, {
    errorMap: () => ({ message: 'ご従業員様数を選択してください' }),
  }),
  email: z
    .string()
    .trim()
    .min(1, 'ご勤務先メールアドレスを入力してください')
    .max(
      MAX_LENGTH,
      `ご勤務先メールアドレスは${MAX_LENGTH}文字以内で入力してください`,
    )
    .email('メールアドレスの形式が正しくありません'),
  message: z
    .string()
    .trim()
    .min(1, 'お問い合わせ内容を入力してください')
    .max(
      MESSAGE_MAX_LENGTH,
      `お問い合わせ内容は${MESSAGE_MAX_LENGTH}文字以内で入力してください`,
    ),
  privacyPolicyAgreed: z.literal(true, {
    errorMap: () => ({ message: 'プライバシーポリシーへの同意が必要です' }),
  }),
})

export type CorpInquiryValues = z.infer<typeof corpInquirySchema>

export const CORP_INQUIRY_FIELDS = Object.keys(
  corpInquirySchema.shape,
) as (keyof CorpInquiryValues)[]
